<template>
  <div id="responses-view-container">
    <div
      class="response-summary"
    >{{`${numResponses()} out of ${numTeachers} (${percentRespoded()}%) responded`}}</div>
    <div id="response-view-selector">
      <div
        class="view-selector summary-view"
        :class="{'selected-response-view': selectedView === 'summary'}"
        @click="selectedView = 'summary'"
      >SUMMARY</div>
      <div
        class="view-selector individual-view"
        :class="{'selected-response-view': selectedView === 'individual'}"
        @click="selectedView = 'individual'"
      >INDIVIDUAL</div>
    </div>
    <ResponseSummary v-if="selectedView === 'summary'" :questions="questions" />
    <IndividualResponses
      :questions="questions"
      :teachers="teachers"
      v-if="selectedView === 'individual'"
    />
  </div>
</template>

<script>
import IndividualResponses from "./IndividualResponses.vue";
import ResponseSummary from "./ResponseSummary.vue";

export default {
  props: {
    formName: {
      type: String,
      required: true
    },
    questions: {
      type: Object,
      required: true
    },
    teachers: {
      type: Object,
      required: true
    },
    numTeachers: {
      type: Number
    }
  },
  data() {
    return {
      selectedView: "summary"
    };
  },
  components: {
    ResponseSummary,
    IndividualResponses
  },
  methods: {
    numResponses() {
      return Object.values(this.teachers).reduce((responses, teacher) => {
        return teacher.responses.length > 0 ? ++responses : responses;
      }, 0);
    },
    percentRespoded() {
      return this.numResponses === 0
        ? 0
        : ((this.numResponses() / this.numTeachers) * 100).toFixed(0);
    }
  }
};
</script>

<style scoped>
.response-summary {
  font-size: 1em;
  font-family: Arial, Helvetica, sans-serif;
  color: #2c557d;
  margin: 0 0 1em 0.5em;
}
#response-view-selector {
  display: flex;
  align-items: center;
  background-color: #2c557d;
  width: 13em;
  font-family: Arial, Helvetica, sans-serif;
  margin-left: 0.5em;
  margin-bottom: 3em;
  border-radius: 3px;
}
.view-selector {
  width: 6.5em;
  height: 22px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #2c557d;
  background-color: #ffffff;
  color: #2c557d;
}
.view-selector:hover {
  cursor: pointer;
}
.individual-view {
  width: 6.5em;
  height: 22px;
}
.selected-response-view {
  border: solid 1px #2c557d;
  background-color: #2c557d;
  color: white;
}
</style>